import React, { useContext, useState, useEffect } from 'react';
import {
  Appbar, IconButton, List,
  SegmentedButtons,
} from 'react-native-paper';
import { useMutation, useQuery } from '@apollo/client';
import { ScrollView, View } from 'native-base';
import { useToast } from 'react-native-toast-notifications';
import Flag from 'react-native-flags';
import { useNavigation } from '@react-navigation/native';
import { FindManyEvents } from '../../gql/event/query';
import { FindManySeasons } from '../../gql/season/query';
import { DeleteEvent } from '../../gql/event/mutation';
import { ModalContext } from '../../context/ModalContext';
import EventModal from '../../modals/ManageEvent/CreateEventModal';
import { ISOCODE } from '../../utils/isocode';
import { EVENT_STATUS, EVENT_TYPE, SCREEN_NAMES } from '../../utils/constant';
import SelectSeason from '../../components/commons/SelectSeason';
import RefreshableScreen from '../Refreshable/RefreshableScreen';
import LoadingIndicator from '../../components/commons/LoadingIndicator';

const entriesEventStatuses = Object.entries(EVENT_STATUS);
const entriesEventTypes = Object.entries(EVENT_TYPE);

function ManageEvents() {
  // States
  const [filterEventStatus, setFilterEventStatus] = useState(undefined);
  const [filterEventType, setFilterEventType] = useState(undefined);
  const [selectedSeason, setSelectedSeason] = useState(undefined);

  const navigation = useNavigation();
  const toast = useToast();
  const {
    displayCreateEventModal,
    toggleCreateEventModal,
  } = useContext(ModalContext);

  const { data: seasonsData } = useQuery(FindManySeasons);

  const { data, loading, refetch } = useQuery(FindManyEvents, {
    variables: {
      status: filterEventStatus,
      type: filterEventType,
      seasonId: selectedSeason,
    },
    skip: !selectedSeason,
  });
  const [deleteEvent, { error: deleteError }] = useMutation(DeleteEvent, {
    onCompleted: (_data) => {
      toast.show(_data.deleteEvent.message);
      refetch();
    },
  });

  if (deleteError) toast.show(deleteError.message);

  useEffect(() => {
    if (seasonsData?.findManySeasons?.length > 0 && !selectedSeason) {
      setSelectedSeason(Number(seasonsData.findManySeasons[0].id));
    }
  }, [seasonsData, selectedSeason]);

  return (
    <>
      <Appbar.Header statusBarHeight={60}>
        <View style={{ flexDirection: 'column', width: '100%' }}>
          <View style={{
            flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 16,
          }}
          >
            <SelectSeason
              selectedSeason={selectedSeason}
              setSelectedSeason={setSelectedSeason}
            />
            <Appbar.Action
              icon="message-plus"
              onPress={toggleCreateEventModal}
            />
          </View>
          <View style={{ paddingHorizontal: 16, paddingVertical: 8 }}>
            <SegmentedButtons
              value={filterEventStatus}
              onValueChange={(value) => setFilterEventStatus(value === filterEventStatus
                ? undefined : value)}
              buttons={entriesEventStatuses.map((e) => ({ value: e[0], label: e[1] }))}
            />
          </View>
          <View style={{ paddingHorizontal: 16, paddingVertical: 8 }}>
            <SegmentedButtons
              value={filterEventType}
              onValueChange={(value) => setFilterEventType(value === filterEventType
                ? undefined : value)}
              buttons={entriesEventTypes.map((e) => ({ value: e[0], label: e[1] }))}
            />
          </View>
        </View>
      </Appbar.Header>
      <RefreshableScreen onRefresh={async () => {
        await refetch();
      }}
      >
        {loading && <LoadingIndicator text="Chargement des événements..." />}
        {displayCreateEventModal && <EventModal />}

        <ScrollView>
          {data?.findManyEvents?.map((d) => {
            const splittedLocation = d.location.split(',');
            const country = splittedLocation[splittedLocation.length - 1].trim();
            return (
              <List.Item
                key={d.id}
                title={`${d.name}`}
                description={d.message}
                left={(props) => (
                  <Flag
                    {...props}
                    type="flat"
                    code={Object.entries(ISOCODE).find((e) => e[1] === country)?.[0]}
                    size={32}
                  />
                )}
                right={(props) => (
                  <>
                    <IconButton
                      {...props}
                      icon="application-edit"
                      onPress={() => navigation.navigate({ name: SCREEN_NAMES.EVENT, params: { eventId: d.id } })}
                    />
                    <IconButton
                      {...props}
                      icon="delete"
                      onPress={() => deleteEvent(
                        {
                          variables: { deleteEventId: Number(d.id) },
                        },
                      )}
                    />
                  </>
                )}
              />
            );
          })}
        </ScrollView>
      </RefreshableScreen>
    </>
  );
}

export default ManageEvents;
